export const HOME = "/";
export const ABOUTUS = "/about-us"
export const GALLERY = "/gallery"
export const CONTACT = "/contact-us"
export const SIGNIN = "/signin"
export const SIGNUP = "/signup"
export const FORGOT = "/reset"
export const SIGNOUT = "/signout"
export const TERMS = "/terms"
export const PRIVACY = "/privacy"